<div class="modal-title" appMatDialogDraggable>
  <span [class]="this.iconClass"  *ngIf="this.icon.length > 0"><i class="fa {{this.icon}}"></i></span><h5 class="text-left">{{this.label}}</h5>
  <button *ngIf="this.isCloseButton" class="times modal-close" mat-dialog-close>
    &times;
  </button>
</div>
